import { render, staticRenderFns } from "./CreateDocumentBeneficiaire.vue?vue&type=template&id=0ac6902a&"
import script from "./CreateDocumentBeneficiaire.vue?vue&type=script&lang=ts&"
export * from "./CreateDocumentBeneficiaire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports